export const getApiUrlBrandName = (domain) => {
    let apiUrl = "";
    let brandName = "";
    let oldAdminPanel = false;
    let amendedDomain = domain.replace(/(www\.|member\.|members\.|stg\.|staging\.)/g, "");
    switch (amendedDomain) {
        case "equinoxmarkets.com":
        case "equinox-markets.com":
            apiUrl = "https://api.equinoxmarkets.app";
            brandName = "equinox";
            oldAdminPanel = true;
            break;
        case "360th.net":
        case "360tradehub.com":
        case "tradehub360.com":
        case "360tradehub.net":
        case "tradehub360.net":
            apiUrl = "https://api.360tradehub.app";
            brandName = "360tradehub";
            oldAdminPanel = true;
            break;
        case "antos.io":
        case "antospnc.com":
            apiUrl = "https://api.antospnc.app";
            brandName = "antos";
            oldAdminPanel = true;
            break;
        case "blueoceanfin.com":
        case "blueocex.com":
            apiUrl = "https://api.blueoceanfin.app";
            brandName = "blueocean";
            oldAdminPanel = true;
            break;
        case "fundamarkets.com":
        case "fundamarkets.net":
            apiUrl = "https://api.fundamarkets.app";
            brandName = "funda";
            break;
        case "minosfutures.com":
            apiUrl = "https://api.minosmarkets.app";
            brandName = "minos";
            break;
        case "cronoscap.com":
        case "cronoscap.net":
            apiUrl = "https://api.cronoscap.app";
            brandName = "cronos";
            break;
        case "excotrades.com":
            apiUrl = "https://admin.excotrades.app/graphql";
            brandName = "exco";
            break;
        case "ridgewaymarkets.com":
            apiUrl = "https://admin.ridgewaymarkets.app/graphql";
            brandName = "ridgeway";
            break;
        case "alliumtrades.com":
            apiUrl = "https://admin.alliumtrades.app/graphql";
            brandName = "alliumtrades";
            break;
        case "qvmarkets.com":
            apiUrl = "https://admin.qvmarkets.app/graphql";
            brandName = "qvmarkets";
            break;
        case "metapromarkets.com":
            apiUrl = "https://admin.metapromarkets.app/graphql";
            brandName = "metapro";
            break;
        default:
            apiUrl = "https://api.blueoceanfin.app";
            brandName = "blueocean";
            break;
    }
    return {apiUrl, brandName, oldAdminPanel};
};

export function nFormatter(num, unit) {
    if (!unit) {
        if (num >= 1000000000) {
            return (
                (num / 1000000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") + "B"
            );
        }
        if (num >= 1000000) {
            return (
                (num / 1000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") + "M"
            );
        }
        if (num >= 1000) {
            return (
                (num / 1000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") + "K"
            );
        }
        if (num < -1000000000) {
            return (
                "-" +
                (num / -1000000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") +
                "B"
            );
        }
        if (num < -1000000) {
            return (
                "-" +
                (num / -1000000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") +
                "M"
            );
        }
        if (num < -1000) {
            return (
                "-" +
                (num / -1000)
                    .toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                    })
                    .replace(/\.0$/, "") +
                "K"
            );
        }
    }
    return num.toLocaleString(undefined, {
        maximumFractionDigits: 2,
    });
}
